exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".productCategoryDome{min-width:1020px}.productCategoryDome .categoryCont{min-width:900px}.productCategoryDome .hover-color-ccc{cursor:pointer;padding:0 4px}.productCategoryDome .hover-color-ccc:hover{background-color:#d5e8fc}.productCategoryDome .categoryDetail{width:calc(100% - 370px);right:auto;left:360px}", ""]);

// exports
